import {combineReducers, Reducer} from '@reduxjs/toolkit'

import {routerReducer} from '@web/slices/router'

import {State} from '../interfaces'
import common from '../slices/common'
import error from '../slices/error'
import orderClaimInfo from '../slices/orderClaimInfo'
import pagination from '../slices/pagination'
import productBundle from '../slices/productBundle'
import saleSettlement from '../slices/saleSettlement'
import search from '../slices/search'
import transactionHistory from '../slices/transactionHistory'

const createRootReducer = (): Reducer<State> =>
    combineReducers({
        common,
        error,
        orderClaimInfo,
        pagination,
        productBundle,
        saleSettlement,
        search,
        transactionHistory,
        router: routerReducer,
    })

export default createRootReducer
